class ConfigLoader {
  constructor() {
    this.config = null;
    this.loadPromise = null;
  }

  async loadConfig() {
    if (this.loadPromise) {
      return this.loadPromise;
    }

    this.loadPromise = this._fetchConfig();
    return this.loadPromise;
  }

  async _fetchConfig() {
    try {
      let base_path = window.BASE_PATH;
      if (base_path === '#BASE_PATH#' || base_path === '') base_path = '/';
      console.log(`${base_path}config.json`);
      const response = await fetch(`${base_path}config.json`);
      if (!response.ok) {
        throw new Error(`Failed to load config: ${response.status}`);
      }
      this.config = await response.json();
      return this.config;
    } catch (error) {
      console.warn('Failed to load config.json, using defaults:', error);
      this.config = this._getDefaultConfig();
      return this.config;
    }
  }

  _getDefaultConfig() {
    const mockMode = !process.env.REACT_APP_MOCK_MODE || process.env.REACT_APP_MOCK_MODE === 'true';
    const apiURL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

    return {
      API_BASE_URL: apiURL,
      MOCK_MODE: mockMode,
      VERSION: '1.0.0',
      ENVIRONMENT: 'local',
      PUBLIC_PATH: '',
      BASE_PATH: '',
    };
  }

  getConfig() {
    return this.config;
  }
}

export const configLoader = new ConfigLoader();
